<template>
	<div>
		<q-uploader
			hide-upload-btn
			auto-upload
			inverted
			no-thumbnails
			ref="uploader"
			color="primary"
			:factory="factoryFn"
			:multiple="false"
			:accept="getExtensions"
			@added="fileAdded"
			:disable="disable"
			:max-file-size="max_file_size"
			:label="imageSize + getSize"
			:class="full_width ? 'full-width' : ''"
			@finish="clearUploader"
			:key="key"
		/>

		<q-dialog v-model="crop_modal" :maximized="$q.platform.is.mobile" @hide="uploaderClosed()">
			<q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; max-height: 80vh;'">
				<q-toolbar>
					<q-toolbar-title>{{ $t('crop_image') }}</q-toolbar-title>

					<q-btn flat round dense icon="fal fa-times" v-close-popup />
				</q-toolbar>

				<q-separator />

				<q-card-section class="q-px-xl">
					<cropper
						ref="cropper"
						class="cropper"
						:src="original_image"
						:stencil-props="{
							aspectRatio: 1 / 1,
						}"
					/>

					<div class="row q-mt-sm q-col-gutter-md justify-end">
						<div class="col-xs-12 col-sm-4" :class="getOrder('cancel')">
							<q-btn
								color="accent"
								class="full-width"
								:label="$t('cancel')"
								@click="canceledCrop()"
							/>
						</div>

						<div class="col-xs-12 col-sm-4" :class="getOrder('crop')">
							<q-btn color="primary" class="full-width" :label="$t('crop')" @click="cropImage()" />
						</div>
					</div>
				</q-card-section>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { BlobServiceClient } from '@azure/storage-blob'

export default {
	i18nOptions: { namespaces: ['custom', 'common'] },

	props: [
		'max_file_size',
		'content_type',
		'cropper',
		'error',
		'filename',
		'slug',
		'client_id',
		'file',
		'aspect_ratio',
		'disable',
		'aspect_ratio_string',
		'custom_directory',
		'full_width',
	],

	data() {
		return {
			cancel_token: '',
			crop_modal: false,
			original_image: '',
			source: '',
			upload_url: process.env.API_URL + '/files/policy/',
			urls: [],
			policy: null,
			file_data: null,
			key: '',
		}
	},

	components: {
		Cropper,
	},

	computed: {
		getExtensions() {
			switch (this.content_type) {
				case 'images':
					return 'image/jpg,image/jpeg,image/png'
				case 'video':
					return 'video/mp4,video/mkv'
				case 'pdf':
					return 'application/pdf'
				case 'scorm_cloud':
				case 'scorm':
					return 'zip'
				case 'flash':
					return 'application/x-shockwave-flash'
				case 'audio':
					return 'audio/mpeg,audio/ogg,audio/wav'
				case 'html':
					return 'zip'
				case 'xlsx':
					return 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				default:
					return ''
			}
		},

		getHelper() {
			switch (this.content_type) {
				case 'images':
					return 'helper_uploader_images'
				case 'video':
					return 'helper_uploader_videos'
				case 'pdf':
					return 'helper_uploader_presentation'
				case 'scorm_cloud':
				case 'scorm':
					return 'helper_uploader_scorm'
				case 'flash':
					return 'helper_uploader_flash'
				case 'audio':
					return 'helper_uploader_audio'
				case 'html':
					return 'helper_uploader_html'
				case 'xlsx':
					return 'helper_uploader_xlsx'
				default:
					return 'helper_uploader_file'
			}
		},

		imageSize() {
			if (this.content_type === 'images') {
				if (this.aspect_ratio_string) {
					let size = this.getCroppedSize
					return `${this.$t('image_size')}: ${size.width}px / ${size.height}px`
				} else {
					return this.$t('select_a_image')
				}
			} else return this.$t('select_a_file')
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getCroppedSize() {
			if (this.aspect_ratio_string) {
				switch (this.aspect_ratio_string) {
					case '16/9':
						return {
							width: 1280,
							height: 720,
						}
					case '1/1':
						return {
							width: 1280,
							height: 1280,
						}
					case '1200/457':
						return {
							width: 1200,
							height: 457,
						}
					case '790/520':
						return {
							width: 790,
							height: 520,
						}
					case '100/97':
						return {
							width: 500,
							height: 485,
						}
					case '128/25':
						return {
							width: 1280,
							height: 250,
						}
					case '5/3':
						return {
							width: 500,
							height: 300,
						}
					case '600/334':
						return {
							width: 600,
							height: 334,
						}
					case '395/100':
						return {
							width: 395,
							height: 100,
						}
					case '600/338':
						return {
							width: 600,
							height: 338,
						}
					case '830/580':
						return {
							width: 830,
							height: 580,
						}
					case '600/400':
						return {
							width: 600,
							height: 400,
						}
					case '650/650':
						return {
							width: 650,
							height: 650,
						}
					default:
						return {
							width: 1280,
							height: 720,
						}
				}
			} else
				return {
					width: 1280,
					height: 720,
				}
		},

		getSize() {
			switch (this.max_file_size) {
				case '10000000':
					return ' (10mb)'
				default:
					return ''
			}
		},
	},

	methods: {
		showCropper(file) {
			const reader = new FileReader()
			reader.onload = (event) => {
				this.original_image = event.target.result
				// this.$refs.cropper.replace(event.target.result)
			}
			reader.readAsDataURL(file)
			this.crop_modal = true
		},

		cropImage() {
			const { image, canvas } = this.$refs.cropper.getResult()

			var newFile = this.dataURItoBlob(canvas.toDataURL())
			newFile.cropped = true
			newFile.name = Math.random().toString(36).substr(2, 9) + '.jpg'

			this.crop_modal = false
			this.$refs.uploader.addFiles([newFile])
			this.original_image = null
		},

		canceledCrop() {
			this.$refs.uploader.reset()
			this.crop_modal = false
		},

		fileAdded(file) {
			this.$refs.uploader.upload()
		},

		factoryFn(files) {
			this.$q.loading.show()
			this.$emit('uploadStarted', [])

			return new Promise((resolve) => {
				let file = files[0]
				let fd_policy = new FormData()
				fd_policy.append(
					'filename',
					this.filename ? `${this.filename}.${file.name.split('.')[1]}` : file.name
				)

				if (this.custom_directory) {
					fd_policy.append('file_directory', this.custom_directory)
				}

				this.$axios
					.post('/api/files/policy/', fd_policy, { cancelToken: this.source.token })
					.then((response) => {
						if (response.data.origin === 'azure') {
							const blobServiceClient = new BlobServiceClient(
								`${response.data.base_url}?${response.data.sas_token}`
							)

							const main = async () => {
								const container_client = blobServiceClient.getContainerClient('')

								const block_blob_client = container_client.getBlockBlobClient(
									response.data.filename
								)
								const upload_blob_response = await block_blob_client.uploadBrowserData(file, {
									onProgress: (event) => {
										// console.log(event.loadedBytes)
									},
								})

								let fd_complete = new FormData()
								fd_complete.append('uploaded', true)
								fd_complete.append('fileSize', file.size)
								fd_complete.append('file', response.data.file_id)

								this.$axios
									.post('/api/files/complete/', fd_complete)
									.then((response) => {
										this.$emit('fileUploaded', response.data.fileUrlSigned, response.data.fileUrlSigned)
									})
									.finally(() => {
										resolve()
									})
							}

							main()
						} else {
							let content_type = file.type != '' ? file.type : 'application/octet-stream'
							let policy = response.data
							let file_name = policy.filename
							let key_path = policy.file_bucket_path

							let fd_s3 = new FormData()
							fd_s3.append('key', key_path + file_name)
							fd_s3.append('acl', 'private')
							fd_s3.append('Content-Type', content_type)
							fd_s3.append('AWSAccessKeyId', policy.key)
							fd_s3.append('Policy', policy.policy)
							fd_s3.append('filename', file_name)
							fd_s3.append('Signature', policy.signature)
							fd_s3.append('file', file)

							this.cancel_token = this.$axios.CancelToken
							this.source = this.cancel_token.source()

							this.$axios
								.post(process.env.BUCKET_URL, fd_s3, {
									onUploadProgress: (event) => {
										// console.log(event)
									},
									cancelToken: this.source.token,
								})
								.then((response) => {
									let fd_complete = new FormData()
									fd_complete.append('uploaded', true)
									fd_complete.append('fileSize', file.size)
									fd_complete.append('file', policy.file_id)

									this.$axios.post('/api/files/complete/', fd_complete).then((response) => {
										this.$emit('fileUploaded', response.data.fileUrlSigned, response.data.fileUrlSigned)
									})
								})
								.finally(() => {
									resolve()
								})
						}
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			})
		},

		uploaderClosed() {
			this.$emit('uploaderClosed', [])
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'crop') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		dataURItoBlob(dataURI) {
			var byteString = atob(dataURI.split(',')[1])
			var ab = new ArrayBuffer(byteString.length)
			var ia = new Uint8Array(ab)
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i)
			}
			return new Blob([ab], { type: 'image/jpeg' })
		},

		clearUploader() {
			this.$refs.uploader.reset()
			this.key = new Date().getTime()
		},
	},

	watch: {
		file: function () {
			if (this.file) this.showCropper(this.file)
		},
	},
}
</script>

<style></style>
